import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useQuote } from "./Header";
import { fadeUp } from "../../lib/motion";

export default function ProductCard({ product, index = 0, priority = false }) {
  const openQuote = useQuote();
  return (
    <motion.div
      variants={fadeUp}
      custom={index}
      className="group bg-white border border-[#E2E8E4] rounded-2xl overflow-hidden hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-[#1D6B2A]/10 transition-all duration-500"
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/products/${product.slug}`} className="block relative aspect-[4/3] overflow-hidden bg-[#F8FAF8]">
        <img
          src={product.image}
          alt={product.name}
          width="600"
          height="450"
          loading={priority ? "eager" : "lazy"}
          fetchpriority={priority ? "high" : "auto"}
          decoding="async"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
        <span className="absolute top-3 left-3 bg-white/90 backdrop-blur text-[#1D6B2A] text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full">
          {product.category_name}
        </span>
      </Link>
      <div className="p-5">
        <Link to={`/products/${product.slug}`}>
          <h3 className="font-head text-lg font-semibold text-[#0A1C0E] group-hover:text-[#1D6B2A] transition-colors leading-snug">
            {product.name}
          </h3>
        </Link>
        <p className="text-sm text-[#3A4D3E] mt-1.5 line-clamp-2">{product.description}</p>
        <div className="mt-4 flex items-center gap-2">
          <button
            onClick={() => openQuote({ name: product.name, sku: product.sku })}
            data-testid={`card-quote-${product.slug}`}
            className="flex-1 bg-[#1D6B2A] text-white rounded-full px-4 py-2.5 text-sm font-semibold hover:bg-[#154d1e] transition-colors"
          >
            Get a Quote
          </button>
          <Link
            to={`/products/${product.slug}`}
            className="grid place-items-center w-10 h-10 rounded-full border border-[#E2E8E4] text-[#1D6B2A] hover:bg-[#F8FAF8] transition-colors"
            aria-label="View details"
          >
            <ArrowUpRight size={18} />
          </Link>
        </div>
      </div>
    </motion.div>
  );
}
